/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkCreateDocumentDto } from '../../models/bulk-create-document-dto';
import { BulkOperationResultDto } from '../../models/bulk-operation-result-dto';

export interface DocumentsControllerBulkCreateDocuments$Params {
      body: BulkCreateDocumentDto
}

export function documentsControllerBulkCreateDocuments(http: HttpClient, rootUrl: string, params: DocumentsControllerBulkCreateDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkOperationResultDto>> {
  const rb = new RequestBuilder(rootUrl, documentsControllerBulkCreateDocuments.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkOperationResultDto>;
    })
  );
}

documentsControllerBulkCreateDocuments.PATH = '/thalea-documents/documents/bulk';
